/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./http-client";

export class StripePaymentController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags stripe-payment-controller
   * @name InitializePayment
   * @summary Initialize a Stripe payment for a process step
   * @request POST:/api/v1/stripe-payment/{processExecutionId}/{stepExecutionId}
   */
  initializePayment = (processExecutionId: number, stepExecutionId: number, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/api/v1/stripe-payment/${processExecutionId}/${stepExecutionId}`,
      method: "POST",
      ...params,
    });
  /**
   * No description
   *
   * @tags stripe-payment-controller
   * @name HandleWebhook
   * @summary Stripe webhook handler for process payments
   * @request POST:/api/stripe-payment/webhook
   */
  handleWebhook = (data: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/api/stripe-payment/webhook`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags stripe-payment-controller
   * @name GetPaymentStatus
   * @summary Get Stripe payment status by step id and session id
   * @request GET:/api/v1/stripe-payment/status/{stepExecutionId}/{sessionId}
   */
  getPaymentStatus = (stepExecutionId: number, sessionId: string, params: RequestParams = {}) =>
    this.request<"started" | "pending" | "completed" | "failed", any>({
      path: `/api/v1/stripe-payment/status/${stepExecutionId}/${sessionId}`,
      method: "GET",
      ...params,
    });
}
